<ng-container [formGroup]="formGroup">
  <label *ngIf="['heading', 'boolean'].indexOf(field.widget.type) === -1" for="{{ field.id }}">{{ field.title }}</label>
  <ng-container [ngSwitch]="field.widget.type">
    <ng-container *ngSwitchCase="'heading'">
      <h3>{{ field.title }}</h3>
    </ng-container>
    <ng-container *ngSwitchCase="'string'">
      <mat-form-field appearance="outline">
        <input matInput [placeholder]="field.widget.placeholder"  type="text" [formControl]="formGroup.get(field.id)">
      </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'number'">
      <mat-form-field appearance="outline">
        <input matInput [placeholder]="field.widget.placeholder"  type="number" [formControl]="formGroup.get(field.id)">
      </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'email'">
      <mat-form-field appearance="outline">
        <input matInput [placeholder]="field.widget.placeholder"  type="email" [formControl]="formGroup.get(field.id)">
      </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'password'">
      <mat-form-field appearance="outline">
        <input matInput [placeholder]="field.widget.placeholder"  type="password" [formControl]="formGroup.get(field.id)">
      </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'text'">
      <textarea matInput [placeholder]="field.widget.placeholder" [formControl]="formGroup.get(field.id)">
      </textarea>
    </ng-container>
    <ng-container *ngSwitchCase="'select'">
      <mat-form-field appearance="outline">
        <mat-label *ngIf="field.widget.showInlineLabel">{{ field.title }}</mat-label>
        <mat-select [formControl]="formGroup.get(field.id)"
                    [placeholder]="field.widget.placeholder"
        >
            <mat-option>
                <ngx-mat-select-search
                     [formControl]="searchCtrl"
                     placeholderLabel="Search..."
                     i18n-placeholderLabel
                     noEntriesFoundLabel="no item found"
                     i18n-noEntriesFoundLabel
                  ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option._id || option.id" [title]="option.name">{{ option.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'multiSelect'">
      <mat-form-field appearance="outline">
          <mat-label *ngIf="field.widget.showInlineLabel">{{ field.title }}</mat-label>
          <mat-select multiple [formControl]="formGroup.get(field.id)"
                      [placeholder]="field.widget.placeholder" #multiSelect>
              <mat-option>
                  <ngx-mat-select-search
                       [formControl]="searchCtrl"
                       placeholderLabel="Search..."
                       i18n-placeholderLabel
                       noEntriesFoundLabel="no item found"
                       i18n-noEntriesFoundLabel
                    ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option._id || option.id" [title]="option.name">{{ option.name }}</mat-option>
          </mat-select>
        </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'selectableList'">
      <eas-selectable-list formControlName="{{field.id}}" [title]="field.title" [items]="field.options.categories"
        [options]="field.options.options"></eas-selectable-list>
    </ng-container>
    <ng-container *ngSwitchCase="'treeEditorFormControl'">
      <eas-tree-editor-form-control formControlName="{{field.id}}"
                                    [options]="field.options.options">
      </eas-tree-editor-form-control>
    </ng-container>
    <ng-container *ngSwitchCase="'treeSelectorFormControl'">
      <eas-tree-selector-form-control formControlName="{{field.id}}"
                                      [nodes]="field.options.categories"
                                      [options]="field.options.options">
      </eas-tree-selector-form-control>
    </ng-container>
    <ng-container *ngSwitchCase="'gmc'">
      <eas-gmc-form-control formControlName="{{field.id}}"></eas-gmc-form-control>
    </ng-container>
    <ng-container *ngSwitchCase="'likert'">
      <mat-form-field appearance="outline">
        <mat-select formControlName="{{field.id}}">
          <mat-option *ngFor="let option of field.options?.categories" [value]="option.id">{{ option.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'date'">
      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="myDatepicker" formControlName="{{field.id}}">
        <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #myDatepicker></mat-datepicker>
      </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'datetime'">
      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="myDatepicker" formControlName="{{field.id}}">
        <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #myDatepicker></mat-datepicker>
      </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'boolean'">
      <mat-checkbox [formControl]="formGroup.get(field.id)">{{ field.title }}</mat-checkbox>
    </ng-container>
    <ng-container *ngSwitchCase="'hidden'">
    </ng-container>
    <ng-container *ngSwitchCase="'file'">
      <eas-file-upload-control [formControl]="formGroup.get(field.id)"></eas-file-upload-control>
    </ng-container>
    <ng-container *ngSwitchDefault i18n>
      Unkown type {{ field.widget.type }}
    </ng-container>
  </ng-container>
  <span *ngIf="formGroup.controls[field.id].errors">
    <span *ngIf="formGroup.controls[field.id].errors.required" i18n>This field is required</span>
    <p *ngIf="formGroup.controls[field.id].errors.gmcInvalidFormat" i18n>GMC Number
      '{{ formGroup.controls[field.id].errors.gmcInvalidFormat.value }}' is not valid!</p>
    <p *ngIf="formGroup.controls[field.id].errors.gmcInvalidNumber" i18n>GMC Number
      '{{ formGroup.controls[field.id].errors.gmcInvalidNumber.value }}' could not be verified!</p>
  </span>
</ng-container>
